module.exports = __webpack_public_path__ + "img/春语.297f76a.png";